// import {
//   Alpine,
//   Livewire
// } from '../../../../vendor/livewire/livewire/dist/livewire.esm.js';
import Alpine from 'alpinejs';

import Collapse from '@alpinejs/collapse';
import Focus from '@alpinejs/focus';
import Intersect from '@alpinejs/intersect';


Alpine.plugin(Collapse);
Alpine.plugin(Intersect);
Alpine.plugin(Focus);

/**
 * Custom Plugins
 */
import emerge from './_emerge';
import headerComponent from './_header';
import marquee from './_marquee';
import postGrid from './_postGrid';
import modal from './_modal';

Alpine.data('headerComponent', headerComponent);

/**
 * Reusable Data Objects
 */
import slider from './_slider.js';

Alpine.plugin(emerge);
Alpine.data('slider', slider);
Alpine.data('postGrid', postGrid);
Alpine.data('marquee', marquee);
Alpine.data('modal', modal);

Alpine.start();
